<div class="container d-flex flex-wrap justify-content-center p-3">
    <div class="col-12 col-md-4">
        <app-beneficiary></app-beneficiary>
    </div>
    <div class="col-12 col-md-8">
        <app-transaction></app-transaction>
    </div>
</div>